import React from "react";

import { createStyles, Theme, withStyles } from "@material-ui/core/styles";
import { KeyboardDatePicker, TimePicker } from "@material-ui/pickers";
import { Button, TextField, Tooltip, Radio, FormControl, InputLabel, Paper, Grid, FormControlLabel, Checkbox, Typography, RadioGroup, IconButton } from "@material-ui/core";
import { CalendarToday, QueryBuilder, ListAlt, Edit, DeleteOutlineOutlined as DeleteIcon, AttachFile, RadioButtonUnchecked, RadioButtonChecked } from "@material-ui/icons";
import filter from '../../../assets/filter.svg';
import DotIcon from "@material-ui/icons/Lens";
import SearchIcon from '@material-ui/icons/Search';
import addIcon from '../../../assets/add.svg';
import unrecognized from '../../../assets/unlink_white.svg';

import moment, { Moment } from "moment";

//Table imports
import MaterialTable from "material-table";
import tableIcons from "../../../utils/editTableIcons";
import OrderDashboard from '../../../models/OrderDashboard';
import RfsStyles from '../rfs.module.css';
import commonStyles from '../../common/common.module.css';
import { ButtonBaseClassKey } from "@material-ui/core/ButtonBase";
import { Badge } from '@material-ui/core';

const styles = (theme: Theme) =>
  createStyles({
    wrapper3: {
      width: "100% !important",
    },
    container: {
      width: "100%",
      marginLeft: "auto",
      marginRight: "auto",
    },
    flexAndRow: {
      display: "flex",
      flexDirection: "row",
    },
    titleWrapper: {
      width: "42%",
    },
    header: {
      marginTop: "-12px",
      marginLeft: "5px",
      width: "112px",
      backgroundColor: "white",
      padding: "0 4px 4px 4px",
      color: "var(--primaryblue)",
    },
    awbActionsList: {
      display: "flex",
      flexDirection: "row",
      width: "95%",
      justifyContent: "space-around",
      gap: '10px'
    },
    button: {
      width: "100%",
      height: "34px",
      textTransform: "none",
    },
    finalise: {
      marginTop: '10px'
    },
    fileUpload: {
      display: "none",
    },
    btnWrapper: {
      display: 'flex',
      justifyContent: 'flex-end',
      width: '100%',
      '& button': {
        fontSize: '13px',
        lineHeight: 1,
        height: '40px',
        width: '110px',
        padding: '8px',
        marginTop: '20px'
      },
    },
    materialIcon: {
      margin: "10px 3px 0",
      fontSize: 20,
      "&:hover": {
        cursor: "pointer",
      },
    },
    materialIcon1: {
      marginTop: "-3px",
      paddingTop: 0,
      paddingBottom: 0,
      fontSize: 20,
      "&:path": {
        paddingLeft: "15px",
        paddingRight: "15px",
      },
      "&:hover": {
        cursor: "pointer",
      },
    },
    materialIcon2: {
      fontSize: 20,
      "&:hover": {
        cursor: "pointer",
      },
    },
    inputField: {
      fontSize: '13px',
    },
    searchField: {
      '& fieldset':{
        borderRadius: '20px'
      }
    },
    blue: {
      fontSize: '14px'
    },
    filterButton: {
      background: 'rgba(9, 43, 74, 1)',
      minWidth: '30px',
      height: '30px',
      padding: '5px 3px',
      borderRadius: '5px',
    },
    iconSearch: {
      fontSize: '22px',
    },
    filter: {
      marginLeft: "0px !important",
    },
    deleteDisable: {
      color: "rgb(204, 204, 204)",
    },
    dateicon: {
      marginRight: "15px",
      width: "18px",
      height: "18px",
      marginBottom: "5px",
    },
    iconColor: {
      color: 'white',
      cursor: 'pointer',
      margin: 0,
      padding: '2px 4px',
      fontSize: '10px',
      borderRadius: '3px',
      backgroundColor: 'green',
      fontWeight: 'bold',
      lineHeight: 'normal',
    },
    green :{
      color: 'green !important',
      fontSize: '18px'
    },
    red: {
      color: 'red !important',
      fontSize: '18px'
    },
    inputLabel: {
      fontSize: '10px !important',
      paddingLeft: '12px !important',
    },
    group: {
      flexDirection: 'row',
      marginTop: '15px',
    },
    btns:{
      marginTop: '10px',
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      gap: '20px',
      flexDirection: 'row',
    },
    docBtn:{
      margin: '0 0 20px 0',
    },
    docBtnimg: {
      marginLeft: 'auto',
    },
    radioBtn: {
      padding: 2
    },
    unRecIcon: {
      backgroundColor: 'var(--primaryblue)',
      width: '30px',
      height: '30px',
      borderRadius: '8px',
      padding: '6px',
      boxSizing: 'border-box',
    },
    '@media (max-width:600px)': {
      group: {
        marginTop: '0',
        marginRight: '20px',
        marginBottom: '20px',
      }
    },
    // Modern UI Enhancements
    rowSelected: {
      backgroundColor: 'var(--primaryblue) !important',
      color: '#fff !important'
    },
    filterPaper: {
      padding: '24px 32px',
      marginBottom: '24px',
      marginTop: '0',
      borderRadius: '12px',
      boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
      backgroundColor: '#fff'
    },
    tablePaper: {
      borderRadius: '12px',
      overflow: 'hidden',
      boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
      padding: '0'
    },
    sectionTitle: {
      color: 'var(--primaryblue)',
      fontWeight: 600,
      fontSize: '18px',
      marginBottom: '16px',
      display: 'flex',
      alignItems: 'center',
      gap: '8px'
    },
    actionButton: {
      borderRadius: '8px',
      textTransform: 'none',
      fontWeight: 500,
      padding: '8px 24px',
      boxShadow: 'none',
      '&:hover': {
        boxShadow: 'none',
        backgroundColor: '#072038'
      }
    },
    filterSearchButton: {
      borderRadius: '6px',
      background: 'var(--primaryblue)',
      marginRight: '8px',
      padding: '4px',
      width: '24px',
      height: '24px',
      marginTop: '3px',
      '&:hover': {
        background: 'var(--primaryblue)',
      },
      '& svg': {
        color: '#fff',
      },
    },
    customButton: {
      textTransform: 'inherit',
      padding: '4px 18px',
    }
  });

interface ManageRfsProps {
  classes: any;
  userId: number;
  fromDate: Moment;
  toDate: Moment;
  fromTime: Moment;
  toTime: Moment;
  isTcModalOpen: boolean;
  handleChangeDate: (dateType: string, event: any) => void;
  handleChangeTime: (timeType: string, event: any) => void;
  openDialog: (boxType: string, id?: number, orderNumber?: string) => void;
  ordersList: Array<OrderDashboard>;
  handlefilter: () => void;
  handleNumberChange: (event: React.ChangeEvent<HTMLInputElement>, id: number) => void;
  selectedNumber: number;
  handleCreateRfs: () => void;
  handleChange: (type: string, event: any) => void;
  onClick: (event: any) => void;
  handleDelete: (id: number) => void;
  handleEdit: (id: number) => void;
  mvt: string;
  ghaOrigin?: string;
  handleShowUnrecognizedDocs?: () => void;
  displayUnrecognizedDocs: boolean;
  countUnrecognizedDocs: number;
}


const manageRfsSetup = (props: ManageRfsProps) => {
  const { classes, fromDate, fromTime, toDate, toTime } = props;

  let colorsClass: string = classes.blue;

  return (
    <React.Fragment>

      <div>
        <div className={`${commonStyles.wrapper}` }>
          <h3 className={commonStyles.header}>Filter Options</h3>
            <Grid container spacing={3} alignItems="center">
              {/* Search */}
              <Grid item lg={2} md={3} xs={12}>
                 <TextField
                    fullWidth
                    variant="outlined"
                    InputLabelProps={{ 
                      shrink: true,
                      className: RfsStyles.labelProp
                    }}
                    label="Search"
                    placeholder="Number"
                    className={RfsStyles.textField}
                    InputProps={{
                      classes: { notchedOutline: RfsStyles.noNotch },
                      endAdornment: (
                        <IconButton size="small" onClick={ props.handlefilter }>
                          <SearchIcon fontSize="small" />
                        </IconButton>
                      ),
                    }}
                  />
              </Grid>
            
              {/* From Date */}
              <Grid item lg={2} md={3} sm={6} xs={12}>
                <KeyboardDatePicker
                  label="From"
                  value={ fromDate }
                  format={ 'DD MMM YYYY' }
                  onChange={ (date: any) => props.handleChangeDate("fromDate", date) }
                  fullWidth
                  inputVariant="outlined"
                  autoOk
                  className={RfsStyles.textField}
                  InputLabelProps={{ shrink: true, className: RfsStyles.labelProp }}
                  InputProps={{ classes: { notchedOutline: RfsStyles.noNotch }}}
                />
              </Grid>

              {/* To Date */}
              <Grid item lg={2} md={3} sm={6} xs={12}>
                <KeyboardDatePicker
                  label="To"
                  value={ toDate }
                  format={ 'DD MMM YYYY' }
                  onChange={ (date) => props.handleChangeDate("toDate", date) }
                  minDate={ fromDate }
                  fullWidth
                  inputVariant="outlined"
                  autoOk
                  className={RfsStyles.textField}
                  InputLabelProps={{ shrink: true, className: RfsStyles.labelProp }}
                  InputProps={{ classes: { notchedOutline: RfsStyles.noNotch }}}
                />
              </Grid>

              {/* MVT */}
              <Grid item lg='auto' md={3} xs={12}>
                <div className={RfsStyles.radioWrapper}>
                  <Typography variant='inherit' className={RfsStyles.checkboxLabel}>DEPT/ARR</Typography>
                    <RadioGroup
                      aria-label="MVT"
                      name="mvt"
                      row
                      value={ props.mvt }
                      onChange={ (event: any) => props.handleChange('mvt', event)}
                    >
                      <FormControlLabel 
                      value="dep" 
                      control={<Radio color="primary" size="small" className={RfsStyles.radioIcon} />} 
                      label={<span className={RfsStyles.radioLabel}>Dep</span>} 
                      className={commonStyles.mr3}
                      />
                      <FormControlLabel 
                      value="arr" 
                      control={<Radio color="primary" size="small" className={RfsStyles.radioIcon} />} 
                      label={<span className={RfsStyles.radioLabel}>Arr</span>} 
                      />
                    </RadioGroup>
                </div>
              </Grid>

              {/* Actions Button */}
              <Grid item lg md={12} xs={12} className={RfsStyles.actionWrapper}>
                <IconButton
                  onClick={props.handlefilter}
                  size="small"
                  classes={{ root: classes.filterSearchButton }}
                >
                  <SearchIcon fontSize="small" 
                  />
                </IconButton>
                <IconButton
                  onClick={props.handleCreateRfs}
                  size="small"
                >
                  <img alt="add" src={addIcon} width={24} 
                  />
                </IconButton>
               </Grid>
            </Grid>
        </div>

        <div className={`${commonStyles.wrapper}` } >
          <div className={ `${commonStyles.fSpaceBtw}` }>
            <h3 className={commonStyles.header}>
              Orders List
            </h3>            
            <div className={`${ RfsStyles.fs0img } ${ classes.docBtnimg }`}>
              <Tooltip title="Un-Recognized Documents">
                <span><Badge className={ classes.badge } color="secondary" badgeContent={ props.countUnrecognizedDocs }>
                  <Button color="primary" variant="contained" disableElevation classes={{ root: classes.customButton }} onClick={ props.handleShowUnrecognizedDocs }>
                      View Unrecognized Docs
                  </Button>
                </Badge></span>
              </Tooltip>
            </div>
          </div>

          <div className= { `${ commonStyles.wrapper } ${ RfsStyles.tblWrapper }  ${ commonStyles.paperTable } ${ commonStyles.SelectTable }` }>
            <MaterialTable
              components={{Container: props => <Paper {...props} elevation={0} className={ commonStyles.paperTable }/> }}
              icons={ tableIcons }
              data={ props.ordersList }
              onRowClick={ (event: any, rowData: any) => props.handleNumberChange(event, rowData.id)}
              columns={[
                { title: "RFS Number", field: "rfs_number",
                render: (rowData: OrderDashboard) => {
                  let number = `${rowData.flight}${rowData.rfs_number}/${moment(rowData.schedule_date,"YYYYMMDD").format('DD-MMM-YYYY').toUpperCase()}`
                  return <b>{number}</b>;
                }, },
                { title: "MVT", field: "mvt",
                  render: (rowData: OrderDashboard) => {
                    let origin = rowData.ord_dst.split('-')[0];
                    let mvt= (props.ghaOrigin===origin)? 'OUT' : 'IN'
                    return <span className={RfsStyles.mvt} style={{
                        backgroundColor: mvt === 'OUT' ? '#e3f2fd' : '#e8f5e9',
                        color: mvt === 'OUT' ? 'var(--primaryblue)' : 'var(--secondarygreen)',
                    }}>{mvt}</span>;
                  },
                },
                { title: "ORG-DES", field: "ord_dst", render: (rowData) => <span>{rowData.ord_dst}</span> },
                { title: "Trucking Co.", field: "trucking_company" },
                { title: "Type", field: "truck_type" },
                { title: "Eqpt", field: "equipment" },
                {
                  title: "Weight",
                  field: "weight",
                  render: (rowData: OrderDashboard) => {
                    let weight = ( rowData.sum_awbs_weight ) ? `${ rowData.sum_awbs_weight }K` : ''
                    return weight;
                  },
                },
                { title: "Awbs", field: "num_awbs" },
                { title: "Dock", field: "dock_name",
                  render: (rowData: OrderDashboard) => {
                    let dockName= (rowData.dock_name)? rowData.dock_name : 'none'
                    return dockName;
                  },
                },
                {
                  title: "Pre",
                  field: "pre",
                  render: (rowData: OrderDashboard) => {

                    const origin = props.ghaOrigin === rowData.ord_dst.split('-')[0];
                    const finalPre = origin ? rowData.is_origin_finalised : rowData.is_finalised;
                    return <DotIcon className={`${finalPre ? classes.green : classes.red}`} />;
                  },
                },
                {
                  title: "Action",
                  headerStyle: { textAlign: "center" },
                  cellStyle: { whiteSpace: 'nowrap' },
                  render: (rowData: OrderDashboard) => {
                    let deleteclassName = (rowData.num_awbs!='0') ? classes.deleteDisable : '';
                    return (
                      <div className={ classes.awbActionsList }>
                        <Tooltip title="View AWBs">
                          <p className={ props.classes.iconColor } onClick={(events) => props.openDialog('viewAwbs', rowData.id)} > AWB</p>
                        </Tooltip>
                        <Tooltip title="Manifest Details">
                          <ListAlt className={ classes.materialIcon2 } onClick={(events) => props.openDialog('ManifestDetails', rowData.id)}/>
                        </Tooltip>
                        <Tooltip title="Attach file">
                          <span>
                            <Badge className={ `${commonStyles.attachmentBadge}` } color="secondary" badgeContent={ rowData.attachment_count }>
                            <AttachFile className={ classes.materialIcon2 } onClick={(events: any) => props.openDialog('attachments', rowData.id, rowData.flight + rowData.rfs_number)}/>
                            </Badge>
                          </span>
                        </Tooltip>
                        <Tooltip title="Edit">
                          <Edit fontSize="small" className={ classes.materialIcon2 } onClick={ () => props.handleEdit(rowData.id) } />
                        </Tooltip>
                        <Tooltip title="Delete">
                          <DeleteIcon className={ classes.materialIcon2 +' '+ deleteclassName } onClick={ () => { rowData.num_awbs === '0' ? props.handleDelete(rowData.id) : null }} />
                        </Tooltip>
                      </div>
                    );
                  },
                },
                { title: "Dept", field: "dept",
                  render: (rowData: OrderDashboard) => {
                    let dept= (rowData.departure_date)? moment(rowData.departure_date,"YYYYMMDD").format('DD-MMM-YYYY').toUpperCase() : moment(rowData.schedule_date,"YYYYMMDD").format('DD-MMM-YYYY').toUpperCase()
                    let deptTime= (rowData.departure_time)? `${rowData.departure_time.replace(/(..?)/g, '$1:').slice(0,-1)} (A)` : `${rowData.schedule_time.replace(/(..?)/g, '$1:').slice(0,-1)} (S)`

                    return <span className={`${(!rowData.departure_date)? classes.grey : ''}`}>{dept +' '+ deptTime}</span>;
                  },
                },
                {
                  title: "Arrv",
                  render: (rowData: OrderDashboard) => {

                    let arrv= (rowData.arrival_date) ? moment(rowData.arrival_date,"YYYYMMDD").format('DD-MMM-YYYY').toUpperCase() : null;
                    let arrvTime= (rowData.arrival_time) ? `${rowData.arrival_time.replace(/(..?)/g, '$1:').slice(0,-1)} (A)` : null;
                    let etaArrv = rowData.driver_eta_timestamp ? `${moment(rowData.driver_eta_timestamp).format('DD-MMM-YYYY hh:mm')}(E)` : moment(rowData.schedule_arr_date,"YYYYMMDD").format('DD-MMM-YYYY').toUpperCase() + ' ' + `${rowData.schedule_arr_time.replace(/(..?)/g, '$1:').slice(0,-1)} (S)`;

                    return <span className={`${(!rowData.arrival_date) ? classes.grey : ''}`}> { arrv ?  arrv + ' '+ arrvTime : etaArrv }</span>;
                  },
                },
              ]}
              options={{
                search: false,
                paging: false,
                showTitle: false,
                rowStyle: ( rowData: OrderDashboard ) => ({
                  backgroundColor: (props.selectedNumber === rowData.id) ? 'var(--primaryblue)' : '#FFF',
                  color: (props.selectedNumber === rowData.id) ? '#fff' : '#000',
                  transition: 'all 0.2s',
                }),
                maxBodyHeight: '420px',
                actionsColumnIndex: -1,
                toolbar: false,
                sorting: true,
                headerStyle: {
                  backgroundColor: 'var(--tbl_head_bkg)',
                  color: 'var(--tbl_head_color)',
                  zIndex: 2,
                },
              }}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};


export default withStyles(styles)(manageRfsSetup);
